import React from 'react'
import PropTypes from 'prop-types'
import { TextField, InputAdornment } from '@mui/material'

const defaultMaskOptions = {
  prefix: '',
  suffix: '',
  includeThousandsSeparator: true,
  thousandsSeparatorSymbol: '.',
  allowDecimal: true,
  decimalSymbol: ',',
  decimalLimit: 2,
  integerLimit: 8,
  allowNegative: false,
  allowLeadingZeroes: false,
}

const CurrencyInput = ({ maskOptions, showAdornment, currencySymbol, size, ...inputProps }) => {
  const options = {
    ...defaultMaskOptions,
    ...maskOptions,
  }

  const handleChange = (event) => {
    const rawValue = event.target.value
    let value = rawValue.replace(options.allowNegative ? /[^0-9,.-]/g : /[^0-9,.]/g, '')

    if (options.decimalSymbol) {
      const [integerPart, ...decimalParts] = value.split(options.decimalSymbol)
      const normalizedInteger = integerPart
        .replace(new RegExp(`\\${options.thousandsSeparatorSymbol}`, 'g'), '')
        .slice(0, options.integerLimit)
      const decimalPart = decimalParts.join('').slice(0, options.decimalLimit)

      value = decimalParts.length > 0
        ? `${normalizedInteger}${options.decimalSymbol}${decimalPart}`
        : normalizedInteger
    }

    if (inputProps.onChange) {
      inputProps.onChange({
        ...event,
        target: {
          ...event.target,
          value,
        },
      })
    }
  }

  return (
    <TextField
      {...inputProps}
      onChange={handleChange}
      variant='outlined'
      size={size || 'small'}
      fullWidth
      InputProps={showAdornment && currencySymbol
        ? {
            startAdornment: <InputAdornment position='start'>{currencySymbol}</InputAdornment>,
          }
        : {}}
    />
  )
}

CurrencyInput.defaultProps = {
  inputMode: 'numeric',
  maskOptions: {},
  currencySymbol: '',
}

CurrencyInput.propTypes = {
  inputmode: PropTypes.string,
  showAdornment: PropTypes.bool,
  size: PropTypes.string,
  currencySymbol: PropTypes.string,
  maskOptions: PropTypes.shape({
    prefix: PropTypes.string,
    suffix: PropTypes.string,
    includeThousandsSeparator: PropTypes.bool,
    thousandsSeparatorSymbol: PropTypes.string,
    allowDecimal: PropTypes.bool,
    decimalSymbol: PropTypes.string,
    decimalLimit: PropTypes.number,
    requireDecimal: PropTypes.bool,
    allowNegative: PropTypes.bool,
    allowLeadingZeroes: PropTypes.bool,
    integerLimit: PropTypes.number,
  }),
}

export default CurrencyInput
